export const SIGN_UP_GOAL = 'WIKI_PROMO_SIGN-UP_CLICK';
export const SIGN_IN_GOAL = 'WIKI_PROMO_SIGN-IN_CLICK';
export const SHOW_GOAL = 'WIKI_PROMO_SHOW';

export const LIGHT_BACKGROUND_URL =
    'https://storage.yandexcloud.net/cloud-www-assets/constructor/services/wiki/background_wiki_2x.png';
export const DARK_BACKGROUND_URL =
    'https://storage.yandexcloud.net/cloud-www-assets/constructor/services/wiki/dark/background_wiki_dark_x2.png';

export const WIKI_ROOT_URL = '/?skipPromo=1';

export const PRIVACY_URL = 'https://yandex.ru/legal/confidential/';
export const TERMS_URL = 'https://yandex.ru/legal/cloud_termsofuse/';
